'use client'

import { twMerge } from '@/lib/classname/twMerge'
import { forwardRef, type CSSProperties, type PropsWithChildren } from 'react'

export type DefinitionListCellElement = 'dt' | 'dd'

export type DefinitionListCellProps = UiComponentProps &
  PropsWithChildren & {
    as?: DefinitionListCellElement
    isBold?: boolean
    style?: CSSProperties
    striped?: boolean
    'aria-hidden'?: boolean
  }

export const DefinitionListCell = forwardRef<HTMLElement, DefinitionListCellProps>(
  function DefinitionListCell(
    {
      as = 'dd',
      children,
      className,
      id,
      isBold = false,
      striped,
      style,
      'data-testid': dataTestId,
      'aria-hidden': ariaHidden,
    },
    ref,
  ) {
    const Component = as

    return (
      <Component
        ref={ref}
        id={id}
        style={style}
        aria-hidden={ariaHidden}
        data-testid={
          dataTestId ?? (as === 'dt' ? 'definition-list-term' : 'definition-list-definition')
        }
        className={twMerge(
          'm-0 rounded-xs px-2 py-0.5 leading-light text-brand-2-900',
          as === 'dd' ? 'flex items-center' : undefined,
          isBold ? 'font-bold' : 'font-medium',
          striped === undefined ? 'odd:bg-brand-2-50' : striped ? 'bg-brand-2-50' : undefined,
          className,
        )}
      >
        {children}
      </Component>
    )
  },
)
